import { useEffect, useState } from 'react';
import { Hours } from '../features/schedule/types';
import { persistSummary, readPersistedSummary } from '../helpers/summary-storage';

interface UsePersistedSummaryProps<T> {
    items: T[];
    controlsDisabled: boolean;
    emptySummary: Hours;
    storageKeys: string[];
    calculateSummary: (items: T[]) => Hours;
}

export default function usePersistedSummary<T>({
    items,
    controlsDisabled,
    emptySummary,
    storageKeys,
    calculateSummary
}: UsePersistedSummaryProps<T>): Hours {
    const storageKey = storageKeys[0];
    const [summary, setSummary] = useState<Hours>(() => readPersistedSummary(storageKeys, emptySummary));

    useEffect(() => {
        if (!items.length) {
            if (controlsDisabled) {
                return;
            }

            setSummary(emptySummary);
            persistSummary(storageKey, emptySummary);
            return;
        }

        const nextSummary = calculateSummary(items);
        setSummary(nextSummary);
        persistSummary(storageKey, nextSummary);
    }, [calculateSummary, controlsDisabled, emptySummary, items, storageKey]);

    return summary;
}
